export default __webpack_public_path__ + "static/media/bg-pattern-home-1.270440fb.svg";